import { useState, useEffect } from "react";

export function useTableRecordsPerPage(headerHeight , rowHeight ) {
  const [recordsPerPage, setRecordsPerPage] = useState(10);

  useEffect(() => {
    const calculateRows = () => {
      const screenHeight = window.innerHeight;
      const availableHeight = screenHeight - headerHeight;
      const rows = Math.floor(availableHeight / rowHeight);
      setRecordsPerPage(rows > 0 ? rows : 1);
    };

    calculateRows();
    window.addEventListener("resize", calculateRows);
    return () => window.removeEventListener("resize", calculateRows);
  }, [headerHeight, rowHeight]);

  return recordsPerPage;
}
